import { apiBasic, apiGet, apiToken } from "./requests";
import { encodeToken } from "./utils";

export const getCorporationInfo = () => {
  let path = "get-corporation-info";
  return apiGet(path);
};

export const getCorporation = () => {
  let path = "corporation/";
  return apiGet(path);
};

export const getCorporationOwner = () => {
  let path = "corporation-owner/";
  return apiGet(path);
};

export const getCorporationBussinessHours = () => {
  let path = "all-business-hours/";
  return apiGet(path);
};

export const updateCorporationBussinessHours = (data) => {
  let path = "business-hours/";
  return apiToken(data, path);
};

export const getCorporationCurrency = () => {
  let path = "corporation-owner/";
  return apiGet(path);
};

export const getAllBusinessHours = () => {
  let path = "all-business-hours/";
  return apiGet(path);
};

export const updateBusinessHours = (payload, businessHoursId) => {
  let path = `business-hours/${businessHoursId}`;
  return apiToken(payload, path, "patch");
};

export const addSpecialClosedDay = (payload) => {
  let path = `special-closed-days`;
  return apiToken(payload, path, "post");
};

export const getSpecialClosedDays = () => {
  let path = `special-closed-days`;
  return apiGet(path);
};

export const editSpecialClosedDay = (payload, specialClosedDayId) => {
  let path = `special-closed-days/${specialClosedDayId}`;
  return apiToken(payload, path, "patch");
};

export const removeSpecialClosedDay = (payload, specialClosedDayId) => {
  let path = `special-closed-days/${specialClosedDayId}`;
  return apiToken(payload, path, "delete");
};

export const updateCorporation = (data) => {
  let path = "corporation/";
  return apiToken(data, path, "patch");
};

export const updateCorporationOwner = (userId, data) => {
  let path = "corporation-owner/" + userId;
  return apiToken(data, path, "patch");
};

export const getPaymentsMethods = () => {
  let path = "payment-methods/";
  return apiGet(path);
};

export const createPaymentMethod = (data) => {
  let path = "payment-methods/";
  return apiToken(data, path);
};

export const updatePaymentMethod = (data, id) => {
  let path = "payment-method/" + id;
  return apiToken(data, path, "patch");
};

export const removePaymentMethod = (data, id) => {
  let path = "payment-method/" + id;
  return apiToken(data, path, "delete");
};

export const toogleStatusPaymentMethod = (data, id) => {
  let path = "payment-method/" + id + "/togglestatus";
  return apiToken(data, path, "patch");
};

///////////// USUARIOS Y PERMISOS ////////////////
// Obtener todos los usuarios de una corporación
export const getUsers = () => {
  let path = "users/";
  return apiGet(path);
};

// Obtener información de un usuario por su ID
export const getUserById = (userId) => {
  let path = `user/${userId}`;
  return apiGet(path);
};

// Crear un nuevo usuario en la corporación
export const createUser = (data) => {
  let path = "create-user/";
  // This endpoint returns plain JSON, including invitation delivery status.
  return apiBasic({ token: encodeToken(data) }, path, "post");
};

// Editar un usuario existente por su ID
export const updateUser = (userId, data) => {
  let path = `user/${userId}`;
  return apiToken(data, path, "patch");
};

// Cambiar la contraseña de un usuario
export const resetUserPassword = (userId, data) => {
  let path = `reset-password/${userId}`;
  return apiToken(data, path, "post");
};

// Activar o desactivar el PIN de un usuario
export const toggleUserPin = (userId) => {
  let path = `toggle-user-pin/${userId}`;
  return apiToken({}, path, "patch");
};

// Eliminar un usuario de la corporación
export const deleteUser = (userId) => {
  let path = `user/${userId}`;
  return apiToken({}, path, "delete");
};

export const getPlatformAccess = (platform) => apiGet(`platforms/${encodeURIComponent(platform)}/access`);

export const getPlataforms = () => {
  let path = `platforms/`;
  return apiGet(path);
};

export const getSalesPoints = () => {
  let path = `points-of-sale/`;
  return apiGet(path);
};

export const newSalesPoint = (data) => {
  let path = `points-of-sale/`;
  return apiBasic(data, path, "post");
};

export const editSalesPoint = (id, data) => {
  let path = `points-of-sale/${id}`;
  return apiBasic(data, path, "patch");
};

export const deleteSalesPoint = (id) => {
  let path = `points-of-sale/${id}`;
  return apiBasic({}, path, "delete");
};

export const getOrderManagers = () => {
  let path = `order-manager/`;
  return apiGet(path);
};

export const newOrderManager = (data) => {
  let path = `order-manager/`;
  return apiBasic(data, path, "post");
};

export const editOrderManager = (id, data) => {
  let path = `order-manager/${id}`;
  return apiBasic(data, path, "patch");
};

export const deleteOrderManager = (id) => {
  let path = `order-manager/${id}`;
  return apiBasic({}, path, "delete");
};

export const updateInvoicingStatus = (data) => {
  let path = `toggle-active-invoicing-status`;
  return apiBasic(data, path, "patch");
};

export const updateInvoicingPrefixes = (data) => {
  let path = `update-invoicing-prefixes`;
  return apiBasic(data, path, "patch");
};

// Series de facturación
export const getInvoiceSeries = (filters = {}) => apiGet("invoice-series", filters);

export const getInvoiceSeriesById = (invoiceSeriesId) => apiGet(`invoice-series/${invoiceSeriesId}`);

export const createInvoiceSeries = (data) => apiBasic(data, "invoice-series", "post");

export const updateInvoiceSeries = (invoiceSeriesId, data) => apiBasic(data, `invoice-series/${invoiceSeriesId}`, "patch");

export const updateAbandonedCartTime = (data) => {
  let path = `update-abandoned-cart-time`;
  return apiBasic(data, path, "patch");
};

export const platforms = (data) => {
  let path = "platforms/";
  return apiBasic({ token: encodeToken(data) }, path, "patch");
};

export const updateBranding = (data) => {
  let path = "update-design-configuration";
  return apiToken(data, path, "patch");
};

export const resendUserInvitation = (userId) => apiBasic({}, `user/${userId}/invitation`, "post");

export const toggleShopMaintenance = () => apiBasic({}, "toggle-active-shop-status", "patch");
export const updateMaintenanceMessage = message => apiBasic({message}, "edit-maintenance-message", "patch");
